export default __webpack_public_path__ + "static/media/404-2.f6fe67ed.png";